import React from 'react';
import { memoWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/memo-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { FavoriteItemsType, RecentItemsType } from './types.tsx';
import { RenderRecentSection } from './recent-section/index.tsx';
import { RenderStarredSection } from './starred-section/index.tsx';
import { RenderMostRecentProjectSection } from './most-recent-project-section/index.tsx';

const Nav4ProjectsSectionsInternal = ({
	favoriteItems,
	recentItems,
	mostRecentProjectItem,
}: {
	favoriteItems: FavoriteItemsType;
	recentItems: RecentItemsType;
	mostRecentProjectItem: React.JSX.Element | null;
}) => (
	<>
		<RenderStarredSection favoriteItems={favoriteItems} />
		<RenderRecentSection recentItems={recentItems} />
		<RenderMostRecentProjectSection projectItem={mostRecentProjectItem} />
	</>
);

export const Nav4ProjectsSections = memoWithCondition(
	() => fg('jfp_magma_jsm-perf-improvement-batch-1'),
	Nav4ProjectsSectionsInternal,
);
